import * as React from "react";
import User from "../../_data/models/User";
import Message from "../../_data/models/Message";
import * as classNames from "classnames";
import Conversation from "../../_data/models/Conversation";
import * as moment from "moment";

interface Props {
    conversation: Conversation;
    recipient: User;
    lastMessage: Message;
    viewConversation: () => void;
}

const ConversationComponent = (props: Props) => {
    const {conversation, recipient, lastMessage, viewConversation} = props;
    const classes = classNames({'active': conversation.unreadCount > 0});

    return (
        <tr className={classes} onClick={viewConversation}>
            <td>{recipient.username()}</td>
            <td className="truncate">
                {lastMessage.content}
            </td>
            <td>{moment(lastMessage.createdAt).fromNow()}</td>
            <td/>
        </tr>
    );
};
export default ConversationComponent;


// WEBPACK FOOTER //
// ./app/client/message/components/ConversationComponent.tsx